// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { _decrypt } from './decrypt';
import { CommitmentPolicy, needs } from '@aws-crypto/material-management-browser';
export function buildDecrypt() {
  var commitmentPolicy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CommitmentPolicy.REQUIRE_ENCRYPT_REQUIRE_DECRYPT;

  /* Precondition: browser buildDecrypt needs a valid commitmentPolicy. */
  needs(CommitmentPolicy[commitmentPolicy], 'Invalid commitment policy.');
  return {
    decrypt: _decrypt.bind({}, commitmentPolicy)
  };
}